// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./fonts.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./global.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./components/index.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./pages/index.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --black: #000;
  --white: #fff;
  --gray: #CDCED2;
  --dark-gray: #90918E;
  --dark-gray3: #9F9F9F;
  --light-gray: #EEEEEE;
  --light-gray2: #F0F0F0;
  --light-gray3: #F2F2F2;
  --light-gray5: #F9F9F9;
  --very-light-gray: #FAFAFA;
  --orange: #FF7F6B;
  --light-orange: #FCD5CF;
  --very-light-orange: #FAF0EF;
  --pink: #FEE5E1;
  --light-pink: #FFE5E1;
  --silver: #E0E0E0;
  --light-dark-silver: #8A8A8F;
  --dark-silver: #4D4D4D;
  --red: #FF4240;
  --yellow: #FFC837;
  --green: #4ABB84;
  --light-green: #E9FFF3;
  --mint: #CCF3EE;
  --green-mint: #01C1AC;
  --purple-blue: #452E7B;
  --gradient: linear-gradient(90deg, #67DEFF 0%, #85D07F 31.58%, #FFE81E 61.4%, #FB5D5D 93.11%);
  --focus: #00c2ff;
  --error: #ff3932;

  --content-max-width: 430px;

  --main-highlight-color: var(--white);

  --body-background-color: var(--very-light-gray);
  --font-family: 'inter';

  --page-side-padding-390: 24px;
  --page-side-padding-360: 9px;

  --input-height: 66px;
  --input-background-color: white;
  --input-border-color: var(--gray);
  --input-placeholder-color: var(--dark-gray);
  --input-indicator-color-valid: var(--bright-green);
  --input-indicator-color-error: var(--error);
  --input-indicator-color-focus: var(--focus);

  --default-shadow: 0 0 10px rgb(0 0 0 / 45%);

  --progress-bar-background: var(--silver);
  --progress-bar-color: var(--orange);

  /* survey-option start */
  --survey-option-background: var(--light-gray);
  --survey-option-background-selected: var(--main-highlight-color);

  --survey-option-background-hover: #c5cbd1;

  --survey-option-color: #000;
  --survey-option-color-selected: var(--main-highlight-color);
  --survey-option-border-color: var(--space-gray);
  --survey-option-border-color-selected: var(--orange);

  --survey-option-radius: 10px;
  --survey-option-content-font-weight: 400;
  /* survey-option end */

  --weight-success-thanks-color: var(--green-mint);

  --payment-method-switcher-border-selected: var(--main-highlight-color);

  --review-author-text-color: var(--dark-gray);

  --select-plan-header-background: rgba(140, 83, 234, 0.2);
}

body {
  font-family: var(--font-family);
  font-style: normal;
  margin: 0;
  font-size: 16px;
}

#app-sub-root {
  display: flex;
  flex-direction: column;
  align-items: center;

  min-height: 100vh;
  background-color: var(--body-background-color);
  position: relative;
}

#content {
  max-width: var(--content-max-width);
  width: 100vw;
  box-sizing: border-box;
}

#content > :not(.page-select-plan) {
  padding-left: var(--page-side-padding-390);
  padding-right: var(--page-side-padding-390);
}

:is(#content) :is(.page-select-plan) :is(.page-title, .description-container, .foto-body-progress-container, .select-plan-block-wrapper, .advantages-section, .bonus-section, .title-reviews, .review-carousel-container) {
  padding-left: var(--page-side-padding-390);
  padding-right: var(--page-side-padding-390);
}

/*#content > :is(.timer-additional-container) {*/
/*  max-width: 100%;*/
/*}*/`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,0BAA0B;EAC1B,iBAAiB;EACjB,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,4BAA4B;EAC5B,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,6FAA6F;EAC7F,gBAAgB;EAChB,gBAAgB;;EAEhB,0BAA0B;;EAE1B,oCAAoC;;EAEpC,+CAA+C;EAC/C,sBAAsB;;EAEtB,6BAA6B;EAC7B,4BAA4B;;EAE5B,oBAAoB;EACpB,+BAA+B;EAC/B,iCAAiC;EACjC,2CAA2C;EAC3C,kDAAkD;EAClD,2CAA2C;EAC3C,2CAA2C;;EAE3C,2CAA2C;;EAE3C,wCAAwC;EACxC,mCAAmC;;EAEnC,wBAAwB;EACxB,6CAA6C;EAC7C,gEAAgE;;EAEhE,yCAAyC;;EAEzC,2BAA2B;EAC3B,2DAA2D;EAC3D,+CAA+C;EAC/C,oDAAoD;;EAEpD,4BAA4B;EAC5B,wCAAwC;EACxC,sBAAsB;;EAEtB,gDAAgD;;EAEhD,sEAAsE;;EAEtE,4CAA4C;;EAE5C,wDAAwD;AAC1D;;AAKA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;;EAEnB,iBAAiB;EACjB,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;EACE,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA,gDAAgD;AAChD,qBAAqB;AACrB,IAAI","sourcesContent":[":root {\n  --black: #000;\n  --white: #fff;\n  --gray: #CDCED2;\n  --dark-gray: #90918E;\n  --dark-gray3: #9F9F9F;\n  --light-gray: #EEEEEE;\n  --light-gray2: #F0F0F0;\n  --light-gray3: #F2F2F2;\n  --light-gray5: #F9F9F9;\n  --very-light-gray: #FAFAFA;\n  --orange: #FF7F6B;\n  --light-orange: #FCD5CF;\n  --very-light-orange: #FAF0EF;\n  --pink: #FEE5E1;\n  --light-pink: #FFE5E1;\n  --silver: #E0E0E0;\n  --light-dark-silver: #8A8A8F;\n  --dark-silver: #4D4D4D;\n  --red: #FF4240;\n  --yellow: #FFC837;\n  --green: #4ABB84;\n  --light-green: #E9FFF3;\n  --mint: #CCF3EE;\n  --green-mint: #01C1AC;\n  --purple-blue: #452E7B;\n  --gradient: linear-gradient(90deg, #67DEFF 0%, #85D07F 31.58%, #FFE81E 61.4%, #FB5D5D 93.11%);\n  --focus: #00c2ff;\n  --error: #ff3932;\n\n  --content-max-width: 430px;\n\n  --main-highlight-color: var(--white);\n\n  --body-background-color: var(--very-light-gray);\n  --font-family: 'inter';\n\n  --page-side-padding-390: 24px;\n  --page-side-padding-360: 9px;\n\n  --input-height: 66px;\n  --input-background-color: white;\n  --input-border-color: var(--gray);\n  --input-placeholder-color: var(--dark-gray);\n  --input-indicator-color-valid: var(--bright-green);\n  --input-indicator-color-error: var(--error);\n  --input-indicator-color-focus: var(--focus);\n\n  --default-shadow: 0 0 10px rgb(0 0 0 / 45%);\n\n  --progress-bar-background: var(--silver);\n  --progress-bar-color: var(--orange);\n\n  /* survey-option start */\n  --survey-option-background: var(--light-gray);\n  --survey-option-background-selected: var(--main-highlight-color);\n\n  --survey-option-background-hover: #c5cbd1;\n\n  --survey-option-color: #000;\n  --survey-option-color-selected: var(--main-highlight-color);\n  --survey-option-border-color: var(--space-gray);\n  --survey-option-border-color-selected: var(--orange);\n\n  --survey-option-radius: 10px;\n  --survey-option-content-font-weight: 400;\n  /* survey-option end */\n\n  --weight-success-thanks-color: var(--green-mint);\n\n  --payment-method-switcher-border-selected: var(--main-highlight-color);\n\n  --review-author-text-color: var(--dark-gray);\n\n  --select-plan-header-background: rgba(140, 83, 234, 0.2);\n}\n\n@import './fonts.css';\n@import './global.css';\n\nbody {\n  font-family: var(--font-family);\n  font-style: normal;\n  margin: 0;\n  font-size: 16px;\n}\n\n#app-sub-root {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  min-height: 100vh;\n  background-color: var(--body-background-color);\n  position: relative;\n}\n\n#content {\n  max-width: var(--content-max-width);\n  width: 100vw;\n  box-sizing: border-box;\n}\n\n#content > :not(.page-select-plan) {\n  padding-left: var(--page-side-padding-390);\n  padding-right: var(--page-side-padding-390);\n}\n\n:is(#content) :is(.page-select-plan) :is(.page-title, .description-container, .foto-body-progress-container, .select-plan-block-wrapper, .advantages-section, .bonus-section, .title-reviews, .review-carousel-container) {\n  padding-left: var(--page-side-padding-390);\n  padding-right: var(--page-side-padding-390);\n}\n\n/*#content > :is(.timer-additional-container) {*/\n/*  max-width: 100%;*/\n/*}*/\n\n@import './components/index.css';\n@import './pages/index.css';"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
